import { DateRangeOutlined, Person2Outlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment';

const useStyles = makeStyles(() => ({
  container: {
    width: '265px',
  },
  info: {
    fontSize: '14px',
    fontWeight: 300,
  },
  section: {
    marginTop: '5px',
  },
}));

type Props = {
  firstName?: string | null;
  lastName?: string | null;
  dateOfDeath?: string;
};

const EstateBalanceSheetClientDetails = ({ firstName, lastName, dateOfDeath }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box display="flex" alignItems="center" mb={1}>
        <Person2Outlined />
        <Box ml={2}>
          <Typography>Client Name</Typography>
        </Box>
      </Box>
      <Typography ml={5} className={classes.info}>
        {firstName} {lastName}
      </Typography>

      {dateOfDeath && (
        <>
          <Box display="flex" alignItems="center" mt={2}>
            <DateRangeOutlined />
            <Box ml={2}>
              <Typography>Date of Death</Typography>
            </Box>
          </Box>
          <Typography ml={5} className={classes.info}>
            {moment(dateOfDeath).format('MMMM Do, YYYY')}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default EstateBalanceSheetClientDetails;
